import * as localizationSchema from '@wix/auto_sdk_multilingual-localization-schema_localization-schema';

export { localizationSchema };
